import { Form, FormInstance } from 'antd'
import { showNotification } from 'shared/common/AppNotification/ui'
import { requiredText } from 'shared/libs/text/requered-text'
import { placeholderClassname, wrapperClassName } from 'shared/model/classnames'

import { addUserInfoFormFields } from 'modules/AccessManage/components/AddUserInfo/addUserInfoFormFields'
import { useUserSelectOptions } from 'modules/AccessManage/hooks/useUserSelectOptions'
import { useUsers } from 'modules/AccessManage/hooks/useUsers'
import UserInfoWrapper from 'modules/AccessManage/ui/UserInfoWrapper'

import CustomSelectField from 'shared/ui/Form/CustomSelectField'
import FormItem from 'shared/ui/Form/FormItem/FormItem'
import FormItems from 'shared/ui/Form/FormItems'
import { Spin } from 'shared/ui/Spin'

import './AddUserInfo.css'

interface Props {
  form: FormInstance<any>
}

const selectClassname = 'userInfoSelect border-light_gray_10'
const AddUserInfo = ({ form }: Props) => {
  const {
    companyOptions,
    isLoadingCompanies,
    branchOptions,
    isLoadingBranches,
  } = useUserSelectOptions()
  const { roleOptions, isRolesFetching } = useUsers()
  const currentBrand = Form.useWatch('company', form)

  const handleClickBranchSelect = () => {
    if (!currentBrand) {
      showNotification({
        type: 'error',
        message: 'Выберите бренд перед филиалом',
      })
    }
  }

  return (
    <UserInfoWrapper title="О пользователе">
      <div className="flex flex-col gap-[16px]">
        <FormItems items={addUserInfoFormFields} />
        <FormItem name={'company'}>
          <CustomSelectField
            notFoundContent={isLoadingCompanies ? <Spin size="small" /> : null}
            placeholder={'Бренд'}
            options={companyOptions}
            className={selectClassname}
            wrapperClassname={wrapperClassName}
            placeholderClassname={placeholderClassname}
            onSelect={() => form.setFieldValue('branch', null)}
          />
        </FormItem>
        <FormItem name={'branch'}>
          <CustomSelectField
            notFoundContent={
              isLoadingBranches ? <Spin size="small" /> : undefined
            }
            placeholder={'Филиал'}
            options={branchOptions}
            className={selectClassname}
            wrapperClassname={wrapperClassName}
            placeholderClassname={placeholderClassname}
            onClick={handleClickBranchSelect}
          />
        </FormItem>
        <FormItem
          name={'role'}
          rules={[{ required: true, message: requiredText }]}
        >
          <CustomSelectField
            notFoundContent={isRolesFetching ? <Spin size="small" /> : null}
            placeholder={'Роль пользователя'}
            options={roleOptions}
            className={selectClassname}
            wrapperClassname={wrapperClassName}
            placeholderClassname={placeholderClassname}
          />
        </FormItem>
      </div>
    </UserInfoWrapper>
  )
}

export default AddUserInfo
